import { Component, OnInit } from '@angular/core';
declare var jquery:any; 
declare var $ :any;
@Component({
  selector: 'app-container',
  templateUrl: './container.component.html',
  styleUrls: ['./container.component.css']
})
export class ContainerComponent implements OnInit {

  constructor() { }

  ngOnInit()/* : void */ {
   
  }

}
